<template>
  <div v-if="system">
    <page-header
      header="Our Partners"
      :subheader="pageIntro"
    ></page-header>

    <div class="w-100 min-h-64 mt-6"> <!-- Core partners -->
      <div class="w-100 flex-col text-center text-white mb-12">
        <h1 class="mb-2 uppercase text-xl text-grey">Partners</h1>
      </div>

      <div class="w-100 flex flex-col md:flex-row flex-wrap -m-2">
        <loader class="w-full" v-if="pages.length === 0"></loader>
        <div
          v-for="partner in partnerPages"
          :key="partner.id"
          class='w-full md:w-1/2 lg:w-1/3 px-2 py-4'
        >
          <panel
            @click.native="goToPartner(partner)"
            class="w-full h-64 pt-6 cursor-pointer"
          >
            <div class="flex min-h-16 border-b pb-2 mb-5 relative">
              <div
                class="w-24 h-24 bg-white rounded border absolute pin-b mb-2 bg-contain bg-no-repeat bg-center"
                :style="{
                  'background-image': `url(${partner.partner_options.image ? partner.partner_options.image : ''})`
                }"
              >
              </div>
              <h1 class="text-sm mb-2 self-end ml-28">{{ partner.title }}</h1>
            </div>
            <p class="text-xs" v-html="nl2br(truncate(partner.partner_options.intro, 300))"></p>
          </panel>
        </div>
      </div>
    </div> <!-- Core partners end -->
  </div>
</template>

<script>
import { nl2br, truncate } from '@/helpers'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['system', 'pages', 'selectedOffice']),

    pageIntro () {
      if (!this.system.name) {
        return ''
      }
      return `Here are some of the companies that ${this.system.name} have partnered with.`
    },

    partnerPages () {
      return this.pages.filter(page => page.published === 1 && page.type === 'partner' && page.partner_options && (page.assigned_network === this.selectedOffice.network_id || page.assigned_network == null))
    }

  },

  methods: {
    nl2br,
    truncate,
    goToPartner (partner) {
      this.$router.push({
        path: `/partner/${partner.slug}`
      })
    }
  }
}
</script>

<style lang="scss">
  .header-shadow {
    text-shadow: rgba(0,0,0,0.5) 1px 1px;
  }

  .platinum-panel-badge {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      right: 10px;
      top: -10px;
      width: 30px;
      height: 50px;
      background-image: url('../assets/images/platinum_member_badge.png');
      background-size: 30px 50px;
    }
  }

  .platinum-bg {
    background: radial-gradient(#e7e6e6, #a6a6a7);
  }
</style>
